import { Button } from "./button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { useProfile } from "../../context/ProfileContext";
import { Card, CardContent } from "./card";

export default function Impersonate({ message, callbackExit }: {message: string, callbackExit: () => void}) {
  const { profile } = useProfile();

  if (!message) {
    return (
      <Card className="w-96 rounded-2xl shadow-md mb-2">
        <CardContent className="">
          <span>Ви: {profile?.account}</span>
        </CardContent>
      </Card>
    );
  }
  return (
    <Card className="w-full max-w-fit rounded-2xl shadow-md mb-2">
      <CardContent className="">
        <Button
          className="text-sm px-4 py-2"
          onClick={() => {
            callbackExit()
          }}><FontAwesomeIcon icon={faRightFromBracket}/> Вийти</Button>{message}
      </CardContent>
    </Card>
  )
}
